import { render, staticRenderFns } from "./ThaiDatePicker.vue?vue&type=template&id=2640d086&scoped=true&"
import script from "./ThaiDatePicker.vue?vue&type=script&lang=js&"
export * from "./ThaiDatePicker.vue?vue&type=script&lang=js&"
import style0 from "./ThaiDatePicker.vue?vue&type=style&index=0&id=2640d086&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2640d086",
  null
  
)

export default component.exports